import { useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';

import { useAuth } from '../../store/AuthStore';
import { useSelectedHomey } from '../../store/SelectedHomeyStore';
import { useUserMe } from '../../store/users/useUserMe';

import { ImageBase } from '../../components/common/ImageBase';
import { Overlay } from '../../components/overlay/Overlay';
import { AnimationRemain } from '../../components/animation/AnimationRemain';

import { HeaderButton } from './HeaderButton';
import { UserMenuOverlay } from './UserMenuOverlay';

export function UserMenu(props) {
  const userMenuTriggerRef = useRef();
  const userMenuTriggerState = useOverlayTriggerState({ defaultOpen: false });
  const userMenuOverlayTrigger = useOverlayTrigger(
    { type: 'menu' },
    userMenuTriggerState,
    userMenuTriggerRef
  );

  const { userMe } = useUserMe();

  function handleHomeySelect({ homeyId }) {
    userMenuTriggerState.close();
    props.onHomeySelect({ homeyId });
  }

  return (
    <>
      <HeaderButton
        {...userMenuOverlayTrigger.triggerProps}
        ref={userMenuTriggerRef}
        title={props.selectedHomey?.name}
        onPress={userMenuTriggerState.toggle}
      >
        <ImageBase
          url={props.cloudUser?.avatar.medium ?? userMe?.avatar}
          width={40}
          height={40}
          round={true}
        />
      </HeaderButton>

      <AnimationRemain condition={userMenuTriggerState.isOpen} delay={200}>
        {(animationRemainProps) => {
          return (
            <Overlay
              targetRef={userMenuTriggerRef}
              overlayProps={userMenuOverlayTrigger.overlayProps}
              overlayTriggerState={userMenuTriggerState}
              offset={10}
              animationRemainProps={animationRemainProps}
              autoFocus={true}
              restoreFocus={true}
            >
              <UserMenuOverlay
                cloudUser={props.cloudUser}
                userMe={userMe}
                selectedHomey={props.selectedHomey}
                onHomeySelect={handleHomeySelect}
              />
            </Overlay>
          );
        }}
      </AnimationRemain>
    </>
  );
}

function Injected(props) {
  const { cloudUser } = useAuth();
  const selectedHomey = useSelectedHomey();

  return <UserMenu cloudUser={cloudUser} selectedHomey={selectedHomey} {...props} />;
}

UserMenu.Injected = Injected;
